export default [
  {
    name: 'project_progress_bar',
    component_path: 'modules/templates/blocks/project/ProjectProgressBar'
  }
]